import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from '../../models/user';
import { PartnerClientSetUpService } from '@services/partner-clientsetup.service';
import { LoaderService } from '@services/loader.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'wsb-partner-dashboard',
  templateUrl: './partner-dashboard.component.html',
  styleUrls: ['./partner-dashboard.component.scss'],
  standalone: false
})
export class PartnerDashboardComponent implements OnInit {
  @ViewChild('pagePartnerDashboard', { static: true }) $pagePartnerDashboard;

  user: User | null;
  referralBaseUrl: string;

  constructor(private clientSetUpService: PartnerClientSetUpService, private loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.show();

    this.clientSetUpService
      .getPartnerUrl()
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(url => {
        this.referralBaseUrl = url['partner-url'];
      });
  }
}
